module.exports = __webpack_public_path__ + "img/aa7be41271a7cadb7d61abd2e0e3fd5c.png";